import { Spinner } from 'react-bootstrap'

const Loader = () => {
  return (
    <Spinner
      animation="border"
      role="status"
      className="shopwave-loader d-block mx-auto"
    />
  )
}

export default Loader
